
    import I18n from 'i18nObj';
    
      import 'translations/wiki.wiki_page_index_item';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('wiki.wiki_page_index_item');
  